import i18n from '@/i18n/locale'
// 导航快速入口
export const quickList = [
  {
    content: i18n.t('订单'),
    icon: 'icon-outlined_order',
    scheme: '',
    tag: 'orders',
  },
  {
    content: i18n.t('券'),
    icon: 'icon-outlined_special',
    // eslint-disable-next-line no-template-curly-in-string
    scheme: 'https://c-h5.didi-food.com/${locale}/sidebar/coupon',
    tag: 'promotions',
  },
  // {
  //   content: i18n.t('我的收藏'),
  //   icon: 'icon-outlined_collection',
  //   scheme: '',
  //   tag: 'favorite',
  // },
]
// 侧边栏入口
export const selEntryList = [
  {
    content: i18n.t('个人资料'),
    icon: 'icon-outline_personalcenter',
    scheme: '',
    tag: 'profile',
    noH5: true,
  },
  // {
  //   content: i18n.t('钱包'),
  //   scheme: '',
  //   icon: 'icon-outlined_payment',
  //   tag: 'payment',
  // },
  {
    content: i18n.t('帮助'),
    scheme: 'https://help.didiglobal.com/passenger-index-new.html',
    icon: 'icon-outlined_help',
    tag: 'help',
    // }, {
    //   content: i18n.t('邀请好友'),
    //   icon: 'icon-outline_invitefriends',
    //   scheme: '',
    //   tag: 'invite',
  },
  {
    content: i18n.t('成为滴滴骑手'),
    icon: 'icon-outline_delivery',
    scheme: '',
    tag: 'delivery',
  },
]

export const selEntryListH5 = selEntryList.filter(item => !item.noH5)

// let data = {
//   errno: 0,
//   errmsg: 'ok',
//   time: 1629191936,
//   data: {
//     selfInfo: { firstName: '', lastName: '', headUrl: '' },
//     sideList: [
//       {
//         items: [
//           {
//             content: '\u8ba2\u5355',
//             scheme: 'gsodacustomer://soda/orderListPage',
//             icon: 'customer_common_icon_order',
//             tag: 'orders',
//           },
//           {
//             content: '\u94b1\u5305',
//             scheme: 'gsodacustomer://soda/walletPage',
//             icon: 'customer_common_icon_wallet',
//             tag: 'payment',
//           },
//           {
//             content: '\u6d88\u606f',
//             scheme: 'gsodacustomer://soda/messagePage',
//             icon: 'customer_common_icon_massage',
//             tag: 'messages',
//           },
//           {
//             content: '\u5ba2\u670d',
//             scheme: 'https://help.didiglobal.com/passenger-index-new.html',
//             icon: 'customer_common_icon_help',
//             tag: 'help',
//           },
//           {
//             content: '\u8bbe\u7f6e',
//             scheme: 'gsodacustomer://soda/settingPage',
//             icon: 'customer_common_icon_setting',
//             tag: 'settings',
//           },
//         ],
//       },
//       {
//         items: [
//           {
//             content: '\u4f18\u60e0\u5238',
//             scheme: 'https://c-h5.didi-food.com/${locale}/sidebar/coupon',
//             icon: 'customer_common_icon_promotions',
//             tag: 'promotions',
//           },
//           {
//             content: '\u6211\u7684\u6536\u85cf',
//             scheme: 'gsodacustomer://soda/myCollectionsPage',
//             icon: 'customer_common_icon_collection',
//             tag: 'favorite',
//           },
//           {
//             content: '\u9080\u8bf7\u597d\u53cb',
//             scheme: 'https://act.didi-food.com/${locale}/c/landingPage',
//             icon: 'customer_common_icon_invite_friends',
//             tag: 'invite',
//           },
//         ],
//       },
//     ],
//     banner: {
//       picture:
//         'https://img0.didiglobal.com/static/soda_public/do1_admBsFDIWY3f5dsXVW3X',
//       url: 'https://act.didi-food.com/${locale}/c/landingPage',
//       activityId: '5764613901033275478',
//     },
//   },
//   requestId: 'D2D489EC6CCEABEEC6446A6636CC8571',
//   traceId: '0a9da090611b7f002e53233703aa6702',
// };
